(function () {
  if (window.__dlxHeroReady) return;
  window.__dlxHeroReady = true;

  function initHero(root) {
    if (root.dataset.dlxInit === 'true') return;
    root.dataset.dlxInit = 'true';

    var eyebrowPanels = Array.prototype.slice.call(root.querySelectorAll('[data-eyebrow-panel]'));
    var bodyPanels = Array.prototype.slice.call(root.querySelectorAll('[data-body-panel]'));
    var mediaPanels = Array.prototype.slice.call(root.querySelectorAll('[data-media-panel]'));
    var pager = root.querySelector('.dlx-hero__pager');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var currentEl = root.querySelector('[data-current]');

    if (!bodyPanels.length || !mediaPanels.length) return;

    // Subtle desktop-only parallax on the ACTIVE product image: it drifts a
    // few pixels against scroll as the section crosses the viewport.
    (function initParallax() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var desktopQuery = window.matchMedia('(min-width: 750px)');
      var maxShift = 14;
      var raf = null;

      function update() {
        raf = null;
        var activeShift = root.querySelector('.dlx-hero__media-panel.is-active .dlx-hero__media-shift');
        if (!activeShift) return;
        if (!desktopQuery.matches) { activeShift.style.transform = ''; return; }
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2);
        var clamped = Math.max(-1, Math.min(1, progress));
        activeShift.style.transform = 'translateY(' + (clamped * maxShift * -1).toFixed(2) + 'px)';
      }

      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      root.addEventListener('dlx-hero:index', update);
      update();
    })();

    if (bodyPanels.length < 2) {
      if (pager) pager.style.display = 'none';
      return;
    }

    var index = 0;
    var auto = root.dataset.auto === 'true';
    var interval = Math.max(parseInt(root.dataset.interval || '6', 10), 3) * 1000;
    var timer = null;

    function pad(n) { return String(n + 1).padStart(2, '0'); }

    function crossfade(panels, i) {
      panels.forEach(function (p, idx) { p.classList.toggle('is-active', idx === i); });
    }

    // The image is the one element that SLIDES rather than blur-crossfades:
    // the outgoing shot slides off one edge while the incoming shot slides in
    // from the other, on the same duration/easing as the text blur.
    function slideMedia(fromIndex, toIndex, dir) {
      var oldPanel = mediaPanels[fromIndex];
      var newPanel = mediaPanels[toIndex];
      if (!oldPanel || !newPanel || oldPanel === newPanel) return;

      var enterFrom = dir === 'prev' ? '-100%' : '100%';
      var exitTo = dir === 'prev' ? '100%' : '-100%';

      newPanel.style.transition = 'none';
      newPanel.style.transform = 'translateX(' + enterFrom + ')';
      newPanel.style.opacity = '0';
      newPanel.style.zIndex = '2';
      oldPanel.style.zIndex = '1';
      newPanel.classList.add('is-active');

      void newPanel.offsetWidth;

      requestAnimationFrame(function () {
        newPanel.style.transition = '';
        newPanel.style.transform = 'translateX(0)';
        newPanel.style.opacity = '1';
        oldPanel.style.transition = '';
        oldPanel.style.transform = 'translateX(' + exitTo + ')';
        oldPanel.style.opacity = '0';
        oldPanel.classList.remove('is-active');
      });
    }

    function apply() {
      crossfade(eyebrowPanels, index);
      crossfade(bodyPanels, index);
      if (currentEl) currentEl.textContent = pad(index);
      root.dispatchEvent(new CustomEvent('dlx-hero:index', { detail: { index: index } }));
      restart();
    }

    function go(i, dir) {
      var newIndex = (i + bodyPanels.length) % bodyPanels.length;
      if (newIndex === index) return;
      slideMedia(index, newIndex, dir);
      index = newIndex;
      apply();
    }

    function next() { go(index + 1, 'next'); }
    function prev() { go(index - 1, 'prev'); }

    function restart() {
      if (!auto) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Swipe-to-advance on the image.
    var mediaStack = root.querySelector('[data-media-stack]');
    var startX = 0, startY = 0, tracking = false;

    function onDown(e) {
      tracking = true;
      startX = e.clientX || 0;
      startY = e.clientY || 0;
    }

    function onUp(e) {
      if (!tracking) return;
      tracking = false;
      var dx = (e.clientX || startX) - startX;
      var dy = (e.clientY || startY) - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next(); else prev();
      }
    }

    if (mediaStack) {
      mediaStack.addEventListener('pointerdown', onDown, { passive: true });
      mediaStack.addEventListener('pointerup', onUp, { passive: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer); else restart();
    });

    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-dlx-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
